import { HTTP_STATUS_CODE, HTTP_STATUS_MESSAGE } from '../../constant/status-code.js';
import { urlNavigate } from './navigation.js';

export const getHandlingError = (response) => {
    let errorMessage;
    const { isAxiosError = false } = response;
    if (response && isAxiosError) {
        const { status = HTTP_STATUS_CODE.INTERNAL_SERVER_ERROR, data = {} } = response?.response ?? {};
        const isLogout = +(data?.['isLogOut'] || '0') == 1;

        switch (true) {
            case status === HTTP_STATUS_CODE.UNAUTHORISED || status === HTTP_STATUS_CODE.NOT_AUTH || isLogout:
                localStorage.setItem('isVerifiedWaiver', false);
                localStorage.setItem('waiver', '{}');
                localStorage.setItem('email', '');
                localStorage.setItem('token', '');
                localStorage.setItem('user', '');
                localStorage.removeItem('emailOTP');

                window.location.href = urlNavigate('online-sales', 'home');
                break;

            case status > HTTP_STATUS_CODE.OK && status < HTTP_STATUS_CODE.INTERNAL_SERVER_ERROR:
                errorMessage = {
                    message: HTTP_STATUS_MESSAGE.BAD_REQUEST,
                    acknowledge: 0,
                };
                break;
            case status >= HTTP_STATUS_CODE.INTERNAL_SERVER_ERROR:
                errorMessage = {
                    message: HTTP_STATUS_MESSAGE.INTERNAL_SERVER_ERROR,
                    acknowledge: 0,
                };
                break;
            default:
                errorMessage = {
                    message: 'Something went wrong',
                    acknowledge: 0,
                };
        }
    }
    return errorMessage;
};
